import React from 'react';
import { useReveal } from '../lib/useReveal';
const COMPARISON_DATA = [{
  situation: 'Querés implementar el método pero no sabés por dónde empezar',
  sinKit: 'Abrís los tomos y te perdés entre tanto contenido',
  conKit: 'Programa de 21 días. Cada día tiene su práctica guiada. Sin abrumación.'
}, {
  situation: 'La ansiedad sube y no tenés nada concreto a mano',
  sinKit: 'Buscás en el celular y terminás scrolleando',
  conKit: 'Roll on anti-ansiedad + meditación + afirmación. Todo listo para ese momento.'
}, {
  situation: 'Llegás al lunes sin saber cómo planificar tu semana holística',
  sinKit: 'Improvisás y a los 3 días abandonás',
  conKit: 'Planner holístico imprimible con tracker de hábitos, registro emocional y de mareas'
}, {
  situation: 'Viene la luna nueva y querés hacer algo pero no sabés qué',
  sinKit: 'Mirás videos en YouTube y te confundís',
  conKit: 'Ritual completo paso a paso con hoja de intenciones imprimible lista para usar'
}, {
  situation: 'Querés meditar pero nada en español se siente realmente tuyo',
  sinKit: 'Audios en inglés que no conectan',
  conKit: '7 meditaciones escritas en tu idioma listas para leer, practicar o grabar con tu voz'
}, {
  situation: 'Necesitás estructura para que el método se vuelva hábito real',
  sinKit: 'Sentís que nunca vas a poder con todo',
  conKit: '21 días de implementación gradual que convierte el método en estilo de vida'
}];
export function ComparisonSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-brand-card py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-65">
      <div className="container mx-auto max-w-4xl" data-id="element-66">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-67">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-6 md:mb-8 text-center text-brand-heading tracking-wide" data-id="element-68">
            🌸 ¿QUÉ AGREGA EL KIT RITUAL PREMIUM?
          </h2>

          <div className="space-y-6" data-id="element-69">
            {COMPARISON_DATA.map((row, i) => <div key={i} className="bg-white rounded-xl border border-brand-border-soft p-5 sm:p-6 shadow-sm" data-id="element-70">
                <h3 className="text-brand-heading font-bold text-lg mb-4 text-center sm:text-left" data-id="element-71">
                  {row.situation}
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-72">
                  <div className="bg-brand-primary/50 rounded-lg p-4 border border-brand-border-soft/50" data-id="element-73">
                    <div className="flex items-start gap-2" data-id="element-74">
                      <span className="text-brand-soft font-bold mt-0.5" data-id="element-75">
                        ✗
                      </span>
                      <div data-id="element-76">
                        <span className="text-brand-soft font-bold text-xs uppercase tracking-wider block mb-1" data-id="element-77">
                          Sin Kit
                        </span>
                        <p className="text-brand-body text-sm" data-id="element-78">{row.sinKit}</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#FCE4EC]/50 rounded-lg p-4 border border-[#E8B4BC]" data-id="element-79">
                    <div className="flex items-start gap-2" data-id="element-80">
                      <span className="text-brand-cta mt-0.5" data-id="element-81">🌸</span>
                      <div data-id="element-82">
                        <span className="text-brand-cta font-bold text-xs uppercase tracking-wider block mb-1" data-id="element-83">
                          Con Kit
                        </span>
                        <p className="text-brand-heading font-medium text-sm" data-id="element-84">
                          {row.conKit}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}